import { render } from "./rocket-add.vue?vue&type=template&id=22560828"
import script from "./rocket-add.vue?vue&type=script&lang=js"
export * from "./rocket-add.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__